const childRoutes = (prop) => [
    {
        path: 'registration-list',
        name: prop + '.registration_list',
        meta: { auth: true },
        component: () => import('../pages/registration-list/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/recommended-list/List.vue')
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        component: () => import('../pages/approved-list/List.vue')
    },
    {
        path: 'stall-participant-registration',
        name: prop + '.stall_participant_registration',
        meta: { auth: true },
        component: () => import('../pages/approved-list/Form.vue')
    },
    {
        path: 'direct-assign-stall',
        name: prop + '.direct_assign_stall',
        meta: { auth: true },
        component: () => import('../pages/direct-assign-stall/List.vue')
    },
    {
        path: 'request-for-stall',
        name: prop + '.request_for_stall',
        meta: { auth: true },
        component: () => import('../pages/request-for-stall/List.vue')
    },
    {
        path: 'ecertificate-list',
        name: prop + '.ecertificate_list',
        meta: { auth: true },
        component: () => import('../pages/ecertificate-list/List.vue')
    },
    {
        path: 'direct-assign-stall-form/:id?',
        name: prop + '.direct_assign_stall_form',
        meta: { auth: true },
        component: () => import('../pages/direct-assign-stall/Form.vue')
    },
    {
        path: 'year-wise-evaluation-criteria-list',
        name: prop + '.year_wise_evaluation_criteria_list',
        meta: { auth: true },
        component: () => import('../pages/year-wise-evaluation-criteria/List.vue')
    },
    {
        path: 'year-wise-evaluation-criteria-form',
        name: prop + '.year_wise_evaluation_criteria_form',
        meta: { auth: true },
        component: () => import('../pages/year-wise-evaluation-criteria/Form.vue')
    },
    {
        path: 'report/stall-status-report',
        name: prop + '.stall_status_report',
        meta: { auth: true },
        component: () => import('../pages/stall-status-report/List.vue')
    },
    {
        path: 'report/event-summary-report',
        name: prop + '.event_summary_report',
        meta: { auth: true },
        component: () => import('../pages/event-summary-report/List.vue')
    },
    {
        path: 'fair-evaluation-list',
        name: prop + '.fair_evaluation_list',
        meta: { auth: true },
        component: () => import('../pages/fair-evaluation-list/List.vue')
    },
    {
        path: 'stall-evaluation',
        name: prop + '.stall_evaluation',
        meta: { auth: true },
        component: () => import('../pages/fair-evaluation-list/Form.vue')
    },
    {
        path: 'report/stall-assign-status-report',
        name: prop + '.stall_assign_status_report',
        meta: { auth: true },
        component: () => import('../pages/stall-assign-status-report/List.vue')
    }
]

const routes = [{
    path: '/awareness-event-service/event-management-system',
    name: 'awareness_event_service.event_management_system',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: childRoutes('awareness_event_service.event_management_system')
}]

export default routes
